import React from "react";
import { createRoot } from "react-dom/client";
import DotField from "./DotField";

export function mountHeroDots(root = document) {
	root.querySelectorAll(".solufy-case-hero, .solufy-article-hero, .service-hero, .studio-service-hero, .solufy-dots-hero").forEach((hero) => {
		if (hero.dataset.dotsMounted) return;
		hero.dataset.dotsMounted = "true";
		const background = document.createElement("div");
		background.className = "solufy-dot-field";
		background.setAttribute("aria-hidden", "true");
		hero.prepend(background);
		createRoot(background).render(
			<DotField dotRadius={1.5} dotSpacing={14} bulgeStrength={67}
				glowRadius={0} sparkle={false} waveAmplitude={0}
				cursorRadius={500} cursorForce={0.1} bulgeOnly
				gradientFrom="#A855F7" gradientTo="#B497CF" glowColor="#120F17" />
		);
	});
}
